import { render } from "./UploadVideo.vue?vue&type=template&id=791b6a98&scoped=true"
import script from "./UploadVideo.vue?vue&type=script&lang=js"
export * from "./UploadVideo.vue?vue&type=script&lang=js"

import "./UploadVideo.vue?vue&type=style&index=0&id=791b6a98&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791b6a98"]])

export default __exports__